/**
 * Spec 193: text → HTML for the report grids.
 *
 * Every grid cell's `displayValue`, every footer cell and every
 * `groupHeaderContent` is HTML: ReportDataGrid and ReportGroupedGrid render them
 * with `dangerouslySetInnerHTML`. CB's own generic cells arrive entity-escaped,
 * but a cell cb2 builds from firm TEXT (a client name, a memo, a CSV value) is
 * whatever a user typed into Centerbase. Unescaped, a client named
 * `<img src=x onerror=…>` runs script in the session of everyone who opens the
 * report, and `Client Three & Sons <Ltd>` loses its `<Ltd>` to the tag stripper.
 *
 * Escape firm text with this before it becomes a cell. The five characters are
 * exactly the ones `stripHtml` (reportGridUtils) decodes, so filtering, sorting
 * and exports read back the text the user typed.
 *
 * A plain module with no imports: reportGridUtils imports it, and cb-api's test
 * suite loads reportGridUtils under a Vite config with no app aliases.
 */
export const escapeHtml = (s) => String(s ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;')
